export enum BaseItemViewAction {
    New = 'new',
    Edit = 'edit',
    Watch = 'watch',
    Copy = 'copy',
}